import styled from 'styled-components';
import { rem } from 'polished';
import Icon from '../Icon';

const StyledBox = styled.div`
  position: relative;
  width: ${rem('136px')};
`;

const StyledIcon = styled(Icon)`
  margin-top: ${rem('-6px')};
  position: absolute;
  right: ${rem('4px')};
  z-index: 2;
`;

const StyledList = styled.ul`
  background-color: ${props => props.theme.colors.dark};
  display: none;
  margin: 0;
  padding: ${rem('16px')} ${rem('20px')} ${rem('7px')} ${rem('30px')};
  position: absolute;
  width: ${rem('136px')};
  z-index: 1;

  &:after {
    border-left: ${rem('10px')} solid transparent;
    border-right: ${rem('10px')} solid transparent;
    border-top: ${rem('12px')} solid ${props => props.theme.colors.light};
    content: '';
    height: 0;
    position: absolute;
    right: ${rem('2px')};
    top: ${rem('-2px')};
    width: 0;
  }

  ${props =>
    props.show &&
    `display:block;
  `};
`;

const ElementList = styled.li`
  display: block;
  padding-left: 0;
  &:before {
    content: none;
  }
`;

const ActionButton = styled.button`
  background-color: transparent;
  border: 0;
  color: ${props => props.theme.colors.light};
  display: block;
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${props => props.theme.fontSize.small};
  margin-bottom: ${rem('12px')};
  padding: 0.545rem 0;
  text-align: left;
  width: 100%;

  &:hover {
    color: ${props => props.theme.colors[props.type]};
  }
`;

export { StyledBox, StyledList, ElementList, ActionButton, StyledIcon };
